import type { InputHTMLAttributes } from "react";
import { User } from "lucide-react";
import styles from "./FormInputs.module.css";

export interface LoginInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  id: string;
  label: string;
  error?: string;
}

export function LoginInput({
  id,
  label,
  error,
  className,
  disabled,
  ...rest
}: LoginInputProps) {
  const errorId = error ? `${id}-error` : undefined;

  return (
    <div className={[styles.field, className].filter(Boolean).join(" ")}>
      <label htmlFor={id} className={styles.label}>
        {label}
      </label>
      <div
        className={[
          styles.control,
          error ? styles.controlError : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <span className={styles.leadingIcon} aria-hidden>
          <User size={18} strokeWidth={1.75} />
        </span>
        <input
          id={id}
          type="text"
          className={styles.input}
          aria-label={label}
          aria-invalid={Boolean(error)}
          aria-describedby={errorId}
          autoComplete="username"
          disabled={disabled}
          {...rest}
        />
      </div>
      {error ? (
        <p id={errorId} className={styles.error} role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
